import { supabase } from '../lib/supabase';

// Convert snake_case to camelCase
const toCamelCase = (obj) => {
  if (!obj) return obj;
  return {
    id: obj?.id,
    title: obj?.title,
    image: obj?.image,
    imageAlt: obj?.image_alt,
    propertyType: obj?.property_type,
    category: obj?.category,
    location: obj?.location,
    bedrooms: obj?.bedrooms,
    bathrooms: obj?.bathrooms,
    area: obj?.area,
    price: obj?.price,
    priceUSD: obj?.price_usd,
    status: obj?.status,
    featured: obj?.featured,
    coordinates: {
      lat: obj?.latitude,
      lng: obj?.longitude,
    },
    description: obj?.description,
    createdAt: obj?.created_at,
    updatedAt: obj?.updated_at,
    isFavorite: false, // Client-side only
  };
};

// Convert camelCase to snake_case
const toSnakeCase = (obj) => {
  return {
    title: obj?.title,
    image: obj?.image,
    image_alt: obj?.imageAlt,
    property_type: obj?.propertyType,
    category: obj?.category,
    location: obj?.location,
    bedrooms: obj?.bedrooms,
    bathrooms: obj?.bathrooms,
    area: obj?.area,
    price: obj?.price,
    price_usd: obj?.priceUSD,
    status: obj?.status,
    featured: obj?.featured,
    latitude: obj?.coordinates?.lat,
    longitude: obj?.coordinates?.lng,
    description: obj?.description,
  };
};

export const propertyService = {
  async getAll() {
    const { data, error } = await supabase?.from('properties')?.select('*')?.order('created_at', { ascending: false });

    if (error) throw error;
    return data?.map(toCamelCase) || [];
  },

  async getById(id) {
    const { data, error } = await supabase?.from('properties')?.select('*')?.eq('id', id)?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async create(property) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('properties')?.insert({ ...toSnakeCase(property), created_by: user?.id })?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async update(id, property) {
    const { data, error } = await supabase?.from('properties')?.update(toSnakeCase(property))?.eq('id', id)?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async delete(id) {
    const { error } = await supabase?.from('properties')?.delete()?.eq('id', id);

    if (error) throw error;
  },

  subscribeToChanges(callback) {
    const channel = supabase?.channel('properties')?.on('postgres_changes', { event: '*', schema: 'public', table: 'properties' }, (payload) => {
        callback(payload);
      })?.subscribe();

    return () => supabase?.removeChannel(channel);
  },
};
